import { Icon } from '@/components/Icon';
import type { AiSummaryController } from './useAiSummary';
import './ai-summary.css';

/*
 * In a module of its own so the toolbar button ships with the reading pane
 * while the panel it opens is a lazy chunk (src/app/lazyUi.ts, #208).
 */
/** The reading-pane toolbar's button. Rendered only while the assistant is on. */
export function AiSummaryButton({ summary }: { summary: AiSummaryController }) {
  return (
    <button
      type="button"
      className="btn btn--ghost ai-summary-button"
      onClick={() => (summary.open ? summary.close() : summary.summarize())}
      aria-expanded={summary.open}
      title="Summarize with AI (Shift+S)"
    >
      <Icon name="sparkle" /> Summarize
    </button>
  );
}
